
<template>
  <div class="container-xs mt-6">
    <div class="card">
      <div class="card-content">
        <h1><span class="glyphicon glyphicon-lock"></span> Login</h1>
        <form @submit.prevent="validateBeforeSubmit('login')" data-vv-scope="login">

          <div class="field">
            <label class="label">{{labels.emailLabel}}</label>
            <div class="control has-icon has-icon-right">
              <input name="email" v-model="model.Email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email'),'is-danger': errored }" type="text" v-on:focus="clear">
              <i v-show="errors.has('email')" class="fa fa-warning"></i>
              <span v-show="errors.has('email')" class="help is-danger">{{errors.first('email')}}</span>
            </div>
          </div>
          <div class="field">
            <label class="label">{{labels.passwordLabel}}</label>
            <div class="control has-icon has-icon-right">
              <input v-model="model.Password" v-validate="'required'" ref="password" name="password" type="password" :class="{'input': true,'is-danger': errored }" v-on:focus="clear">
              <i v-show="errors.has('register.password')" class="fa fa-warning"></i>
              <span v-show="errors.has('register.password')" class="help is-danger">{{errors.first('register.password')}}</span>
            </div>
          </div>
          <span v-show="errored" class="help is-danger">{{errorMessage}}</span>
          <div class="field">
            <div class="control">
              <label class="checkbox">
                <input type="checkbox" value="" checked class="ml-2">
                  Remember me
              </label>
            </div>
          </div>
          <div class="field is-grouped">
            <div class="control">
              <button type="submit" :class="{'button is-primary':true, 'is-loading disabled' : loading }"><span class="glyphicon glyphicon-off"></span> Login</button>
            </div>
            <div class="control">
              <button type="submit" class="button is-light" data-dismiss="modal"><span class="glyphicon glyphicon-remove"></span> Cancel</button>
            </div>
          </div>
        </form>
        <div class="mt-5">
          <p>Not a member? <a href="/">Sign Up</a></p>
          <p>Forgot or don't know your password?<a href="/forgot-password"> Click here</a></p>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    name: 'Login',
    data() {
      return {
        model: {
        },
        errored: false,
        labels: [],
        homeContent: [],
        isPAActive: true,
        isSMEActive: false,
        isCCIActive: false,
        errorMessage: 'Invalid username or password.',
        loading: false
      }
    },
    created() {
      this.$http
        .get('/umbraco/surface/AuthenticationSurface/Login')
        .then(response => {

        })
        .catch(error => {
          this.errored = true
        })
    },
    methods: {
      validateBeforeSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading = true;
            this.$http.post
              (
                '/umbraco/surface/AuthenticationSurface/PostLogin',
                this.model
            )
              .then(response => {
                if (response.data.error) {
                  this.loading = false;
                  this.errored = response.data.error;
                  if (response.data.message)
                    this.errorMessage = response.data.message;
                }
                else if (response.data.successUrl) {
                  this.loading = true;
                  window.location.href = response.data.successUrl;
                }
                  
              })
              .catch(error => {
                this.errored = true;
                this.loading = false;
              })
              
            return;
          }


        });
      },
      clear() {
        this.errored = false;
      },
      logOut() {
        this.$http
          .get(
            '/umbraco/surface/AuthenticationSurface/Logout',
            this.model
          )
          .then(function (response) {
            if (response.data.error)
              alert(response.data.error);
          })
          .catch(function (error) {
          });

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue